"use client"

import * as React from 'react';
import {useContext} from 'react';
import { Sons } from '../../context/theme';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/Drawer';

export default function Menu () {
    const data = useContext(Sons);
    const [state, setState] = React.useState({
        top: false
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ [anchor]: open });
    };

    return <React.Fragment key={'top'}>

<div className="menu-header-open hide" onClick={toggleDrawer('top', true)}>
<span className="menu-toggle-bar menu-toggle-bar--top"></span>
<span className="menu-toggle-bar menu-toggle-bar--middle"></span>
<span className="menu-toggle-bar menu-toggle-bar--bottom"></span>
</div>
        <SwipeableDrawer
            anchor={'top'}
            open={state['top']}
            elevation={32}
            onClose={toggleDrawer('top', false)}
            className={'sons-mui-drawer-container'}
        >
            <div id="menu-wrapper" className="menu-wrapper bg-black">
                <Container className="menu-container">
                    <div className="menu-header">
                        <div className="menu-body">
        <div className="menu1">
            
<div className="menu-header-close">
 <a className="menuclose" title="Close" onClick={toggleDrawer('top', false)}><span class="menucl-f"></span></a>
</div>
            <p>Menu</p>
        <ul>
        <a href="/pre-consultation"><li>Pre Consultation</li></a>
        <a href="/consultation"><li>Consultation</li></a>
        <a href="/customiser"><li>Customiser</li></a>
        <a href="/basket"><li>Basket</li></a>
        <a href="/checkout"><li>Checkout</li></a>
        </ul>
        </div>
        <div className="menu2">
         <ul>
        <a href="https://www.sons.co.uk"><li>sons.co.uk</li></a>
        <a href="#"><li>Delivery & returns</li></a>
        <a href="#"><li>Terms & conditions</li></a>
            </ul>
        </div>
      </div>

                    </div>
                    <div className="menu-body">
                    </div>
                </Container>
            </div>
        </SwipeableDrawer>
    </React.Fragment>;
}